import React from 'react';
import { Mail, Linkedin, Github, MessageCircle, MapPin } from 'lucide-react';

const Contact = () => {
  const contactInfo = [
    {
      icon: <Mail className="w-6 h-6" />,
      title: "Email",
      value: "zaidsaigal2005@gmail.com",
      link: "mailto:zaidsaigal2005@gmail.com",
      color: "from-red-500 to-pink-600"
    },
    {
      icon: <Linkedin className="w-6 h-6" />,
      title: "LinkedIn", 
      value: "Connect with me",
      link: "https://www.linkedin.com/in/zaid-haris-saigal-680967248/",
      color: "from-blue-500 to-cyan-600"
    },
    {
      icon: <Github className="w-6 h-6" />,
      title: "GitHub",
      value: "View my repositories",
      link: "https://github.com/zaidharissheikh",
      color: "from-gray-500 to-gray-700"
    },
    {
      icon: <MapPin className="w-6 h-6" />,
      title: "Location",
      value: "Faisalabad, Pakistan",
      link: "#",
      color: "from-green-500 to-emerald-600"
    }
  ];

  return (
    <section id="contact" className="py-20 bg-gray-900">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Get In <span className="text-cyan-400">Touch</span>
            </h2>
            <div className="w-20 h-1 bg-gradient-to-r from-cyan-400 to-purple-500 mx-auto mb-8"></div>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Ready to bring your ideas to life? Let's connect and discuss your next project!
            </p>
          </div>

          <div className="max-w-4xl mx-auto">
            {/* Contact Information */}
            <div className="text-center mb-12">
              <h3 className="text-2xl font-bold text-white mb-6">Let's Connect</h3>
              <p className="text-gray-300 text-lg mb-8 leading-relaxed">
                I'm always excited to discuss new opportunities, collaborate on interesting projects, 
                or simply have a conversation about technology and development. Feel free to reach out 
                through any of the channels below!
              </p>
            </div>

            {/* Contact Info Cards */}
            <div className="grid md:grid-cols-2 gap-6 mb-12">
              {contactInfo.map((info, index) => (
                <a
                  key={index}
                  href={info.link}
                  target={info.link.startsWith('http') ? "_blank" : "_self"}
                  rel={info.link.startsWith('http') ? "noopener noreferrer" : ""}
                  className="group flex items-center p-6 bg-gray-800/50 backdrop-blur-sm rounded-2xl border border-gray-700 hover:border-gray-600 transition-all duration-300 hover:transform hover:scale-105"
                >
                  <div className={`p-4 bg-gradient-to-r ${info.color} rounded-xl mr-6 group-hover:scale-110 transition-transform duration-300`}>
                    <div className="text-white">
                      {info.icon}
                    </div>
                  </div>
                  <div>
                    <h4 className="text-white font-semibold text-lg mb-1">{info.title}</h4>
                    <p className="text-gray-400 group-hover:text-cyan-400 transition-colors duration-300">
                      {info.value}
                    </p>
                  </div>
                </a>
              ))}
            </div>

            {/* Availability Status */}
            <div className="bg-gradient-to-r from-gray-800/50 to-gray-700/50 backdrop-blur-sm rounded-2xl p-8 border border-gray-600 text-center">
              <div className="flex items-center justify-center mb-4">
                <MessageCircle className="w-6 h-6 text-cyan-400 mr-3" />
                <h4 className="text-white font-semibold text-xl">Current Availability</h4>
              </div>
              <div className="mb-4">
                <span className="inline-flex items-center px-4 py-2 bg-green-500/20 text-green-400 rounded-full font-medium">
                  <div className="w-2 h-2 bg-green-400 rounded-full mr-2 animate-pulse"></div>
                  Available for Projects
                </span>
              </div>
              <p className="text-gray-300 mb-6">
                I'm currently open to freelance projects, full-time opportunities, and collaborations. 
                Let's discuss how we can work together!
              </p>
              <div className="grid md:grid-cols-3 gap-4 text-sm">
                <div className="text-center">
                  <div className="text-cyan-400 font-semibold">Freelance Projects</div>
                  <div className="text-gray-400">Web Development</div>
                </div>
                <div className="text-center">
                  <div className="text-purple-400 font-semibold">Full-time Roles</div>
                  <div className="text-gray-400">MERN Stack Developer</div>
                </div>
                <div className="text-center">
                  <div className="text-pink-400 font-semibold">Collaborations</div>
                  <div className="text-gray-400">Open Source & Learning</div>
                </div>
              </div>
            </div>

            {/* Call to Action */}
            <div className="text-center mt-12">
              <p className="text-gray-300 text-lg mb-6">
                Prefer a direct approach? Reach out via email:
              </p>
              <a
                href="mailto:zaidsaigal2005@gmail.com"
                className="inline-flex items-center bg-gradient-to-r from-cyan-500 to-purple-600 hover:from-cyan-600 hover:to-purple-700 text-white font-semibold py-4 px-8 rounded-lg transition-all duration-300 transform hover:scale-105 hover:shadow-lg hover:shadow-cyan-500/25"
              >
                <Mail className="w-5 h-5 mr-2" />
                Send Email
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
